// @ts-nocheck







export const sumOperations = (
operations,
isContractor) =>
{
  let sum = 0;
  let sumContractor = 0;
  operations.forEach((operation) => {
    sum += operation.hours * operation.count * operation.price;
    if (isContractor) {
      sumContractor +=
      operation.contractorHours * operation.count * operation.contractorPrice;
    }
  });
  return { sum, sumContractor };
};

export const sumPartsAndConsumbles = (
parts) =>
{
  let sum = 0;
  parts.forEach((part) => {
    const stockPartCost = part.stockPart.cost || 0;
    sum += part.count * stockPartCost;
  });
  return { sum, sumContractor: sum };
};
